import { getQuoteSuppliers } from '../../../quotes/quote-service';
import { v6Config } from '../../../../webmodule-common/interop/interfaces/v6-config';
import { v6SupportsVersion } from '../../../../webmodule-common/interop/interfaces/v6-config';
import { v6VersionMap } from '../../../../webmodule-common/interop/interfaces/v6-config';

export async function setSupplierReferenceOverride(akey: string) {
  //DO NOT CALL THIS UNLESS YOU KNOW THE V6 BOOT LOADER IS RUNNING
  if (v6SupportsVersion(v6VersionMap.hasQuoteOwnerLevelSettings)) v6Config().setSupplierReferenceOverrideKey?.(akey);
  await getQuoteSuppliers(true);
}
